export default __webpack_public_path__ + "static/media/Finger-Rings.2146d893.jpg";